'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002493 from "./presto.types$$anon$93.js";
import * as $j_presto$002etypes$0024$002dIp$002dPayload$0024 from "./presto.types$-Ip-Payload$.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Rule$$anon$92(outer) {
  this.cb7 = null;
  this.caZ = null;
  this.cb0 = false;
  this.cb8 = null;
  this.cb9 = false;
  this.cbc = null;
  this.cb5 = null;
  this.cb6 = false;
  this.cb1 = null;
  this.cb2 = false;
  this.cb3 = null;
  this.cb4 = false;
  this.cba = false;
  this.cbb = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.cb7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.cbc = "IpPayload";
}
export { $c_Lpresto_types$Rule$$anon$92 as $c_Lpresto_types$Rule$$anon$92 };
$p = $c_Lpresto_types$Rule$$anon$92.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$92;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$92() {
}
export { $h_Lpresto_types$Rule$$anon$92 as $h_Lpresto_types$Rule$$anon$92 };
$h_Lpresto_types$Rule$$anon$92.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.cb7;
});
$p.M = (function() {
  if ((!this.cb0)) {
    this.caZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.cb0 = true;
  }
  return this.caZ;
});
$p.O = (function() {
  if ((!this.cb9)) {
    this.cb8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.cb9 = true;
  }
  return this.cb8;
});
$p.D = (function() {
  return this.cbc;
});
$p.t = (function() {
  if ((!this.cb6)) {
    this.cb5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ip", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.cb6 = true;
  }
  return this.cb5;
});
$p.N = (function() {
  if ((!this.cb2)) {
    this.cb1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().Tk(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.cb2 = true;
  }
  return this.cb1;
});
$p.Q = (function() {
  if ((!this.cb4)) {
    this.cb3 = new $j_presto$002etypes$0024$0024anon$002493.$c_Lpresto_types$$anon$93();
    this.cb4 = true;
  }
  return this.cb3;
});
$p.v = (function() {
  if ((!this.cbb)) {
    this.cba = false;
    this.cbb = true;
  }
  return this.cba;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee101) => ((p) => \u03b4scrutinee101.cHx(p)))($j_presto$002etypes$0024$002dIp$002dPayload$0024.$m_Lpresto_types$IpPayload$())));
});
var $d_Lpresto_types$Rule$$anon$92 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$92, "presto.types$Rule$$anon$92", ({
  a1m: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$Rule$$anon$92 as $d_Lpresto_types$Rule$$anon$92 };
//# sourceMappingURL=presto.types$-Rule$$anon$92.js.map
